import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { UserTicketRepository } from 'Domain/Repositories';
import { message }              from 'antd';

export const createUserTicketsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createUserTicketsRequest.type),
    mergeMap(action => from(UserTicketRepository.createTickets(action.payload))
      .pipe(
        mergeMap(({ tickets, meta }) => {
          message.success('Tickets wurde erfolgreich erstellt');
          return from([
            Actions.createUserTicketsSuccess({ userTickets: tickets, maxCount: meta?.count })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createUserTicketsFailure({ error }),
          ]);
        })
      )
    ),
  );
};
